module.exports = __webpack_public_path__ + "static/media/signal-2.15f9b5fe.svg";